// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__Bmdev","meals-appear":"AvailableMeals_meals-appear__rAzXl","loading":"AvailableMeals_loading__JcvSE","mealserror":"AvailableMeals_mealserror__ZMngr"};